var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#ADBFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8696 12.4626L10 11.8583C9.9325 11.8942 9.82368 11.9353 9.67447 11.982C9.52483 12.0288 9.39017 12.0526 9.27181 12.0526C9.01972 12.0526 8.84223 12.0057 8.73918 11.9116C8.63689 11.8174 8.58587 11.6403 8.58587 11.3809C8.58587 11.2781 8.60126 11.1249 8.63346 10.9243C8.66466 10.7225 8.70054 10.5431 8.74044 10.3862L9.22723 8.43245C9.27491 8.25315 9.30761 8.05602 9.32518 7.84088C9.34316 7.62622 9.35153 7.47602 9.35153 7.39078C9.35153 6.9788 9.22414 6.64447 8.96928 6.38657C8.71443 6.12886 8.3515 6 7.88119 6C7.61947 6 7.34279 6.05272 7.04996 6.15806C6.75713 6.26312 6.451 6.3897 6.13073 6.53752L6 7.14227C6.09544 7.10225 6.2091 7.05921 6.34209 7.01464C6.4745 6.97027 6.6044 6.94732 6.73078 6.94732C6.98881 6.94732 7.16262 6.9972 7.25371 7.09543C7.34479 7.19394 7.39054 7.36917 7.39054 7.61967C7.39054 7.7582 7.37607 7.91209 7.34605 8.07935C7.31644 8.24765 7.27947 8.42562 7.23597 8.61346L6.74709 10.575C6.70359 10.7812 6.67181 10.9656 6.65182 11.1293C6.632 11.2929 6.62246 11.4534 6.62246 11.6095C6.62246 12.0127 6.75386 12.345 7.01658 12.6073C7.2793 12.8685 7.64766 13 8.12124 13C8.42963 13 8.70029 12.9543 8.93323 12.8624C9.16592 12.7708 9.47841 12.6376 9.8696 12.4626Z",
    fill: "#ADBFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 4.55228 9.55228 5 9 5C8.44772 5 8 4.55228 8 4C8 3.44772 8.44772 3 9 3C9.55228 3 10 3.44772 10 4Z",
    fill: "#ADBFDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.67ea8495c0f88850b8ae33099008c3b9.svg";
export { ForwardRef as ReactComponent };